<template>
  <div id="addtoproject">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li>
          <a href="#/myartworks">My Artworks</a>
        </li>
        <li>
          <a href="#/myartworks">Artwork</a>
        </li>
        <li>
          <a href="#/myartworks">Add to Project</a>
        </li>
      </ol>
    </div>
    <div class="row mlr0 mt30">
      <div class="col-xs-6 prl30">
        <p class="sub-title mb0 mt0 lh25">ADD TO PROJECT</p>
      </div>
      <div class="col-xs-6 text-right prl30">
        <div class="row lh25">
          <div class="pull-right">
            <span class="font20 black click" @click="$router.go(-1)">✕</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content middle add-product" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div class="col-xs-4 text-center">
              <div class="product-img bg inlineb p10" v-viewer>
                <img :src="checkImg(product.img)" class="w100" alt />
              </div>

              <table class="table text-left mt20">
                <tr>
                  <td class="w30 gray">Artwork:</td>
                  <td>{{ product.name }}</td>
                </tr>
              </table>
            </div>
            <div class="col-xs-7 col-xs-offset-1">
              <div class="row">
                <div class="col-xs-12 mt10">
                  <el-input
                    suffix-icon="el-icon-search"
                    placeholder="Find a project"
                    v-model="project_query"
                  ></el-input>
                </div>
              </div>

              <div>
                <table class="table mt30">
                  <tr>
                    <th class="w40">Project Name</th>
                    <th class="text-right pr15">
                      <a
                        :class="{
                          active: sortKey == 'modified_at',
                          desc: reverseSort,
                          sort: true,
                        }"
                        @click="sort_by('modified_at')"
                        >Latest change</a
                      >
                    </th>
                  </tr>
                </table>
              </div>
              <div class="h200">
                <table class="table list-box">
                  <!-- loop start -->
                  <tr
                    v-for="(i, index) in filtered_projects"
                    :key="index"
                    class="click"
                    :class="activeClass == i._id ? 'active' : ''"
                    @click="selectProject(i._id)"
                  >
                    <td class="w40">{{ i.name }}</td>
                    <td class="text-right">
                      {{ new Date(i.modified_at) | dateFormat("DD.MM.YYYY") }}
                    </td>
                  </tr>

                  <!-- loop end -->
                </table>
              </div>
              <div class="row">
                <div class="col-xs-3 text-center">
                  <el-select v-model="roomtype" placeholder>
                    <el-option
                      v-for="(item, key) in roomtypes"
                      :key="key"
                      :label="item.name"
                      :value="item._id"
                    ></el-option>
                  </el-select>
                  Room
                </div>
                <div class="col-xs-3 text-center">
                  <el-input
                    size="medium"
                    placeholder
                    v-model="quantity"
                  ></el-input
                  >Quantity
                </div>
                <div class="col-xs-4 text-center">
                  <div
                    class="click button-select w100"
                    @click="createProduct()"
                  >
                    Add to this project
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
import artworkToProductMixin from "../mixins/artworkToProductMixin";

export default {
  name: "addproduct",
  data() {
    return {
      projectList: [],
      project_query: "",
      activeClass: null,
      product: {},
      loading: false,
      roomtypes: [],
      roomtype: null,
      quantity: null,
      sortKey: "modified_at",
      reverseSort: true,
    };
  },
  mixins: [artworkToProductMixin],
  mounted() {
    this.getData();
  },
  methods: {
    checkImg(img) {
      if (typeof img == "undefined") return;
      if (img.includes("data:image")) {
        return img;
      } else {
        return (
          this.$store.state.serverURL + "/artwork/" + img + "?" + Date.now()
        );
      }
    },
    sort_by(sortKey) {
      this.reverseSort = this.sortKey == sortKey ? !this.reverseSort : false;
      this.sortKey = sortKey;
    },
    sortArrayOfObjects(arr, column, reverse) {
      arr.sort((a, b) => {
        var textA, textB;
        if (column == "modified_at") {
          textA = new Date(a[column]);
          textB = new Date(b[column]);
        } else {
          textA = a[column].toUpperCase();
          textB = b[column].toUpperCase();
        }
        if (!reverse) {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA < textB ? 1 : textA > textB ? -1 : 0;
        }
      });
      return arr;
    },
    async getData() {
      this.loading = true;
      var projectResponse = await axios.get("/project")
      this.projectList = projectResponse.data;
      this.projectList = this.projectList.filter(project => { window.console.log(project.lockProject);return !project.lockProject })
      var artworkResponse = await axios.get("open/artwork/single/" + this.routeParamProductId)
      this.product = artworkResponse.data
      this.loading = false;
    },
    async selectProject(pid) {
      this.activeClass = pid;
      var response = await axios.get("/roomtype/" + pid) 
      this.roomtypes = response.data
      this.roomtype = null;
    },
    change(code) {
      this.activeClass2 = code;
    },
    createProduct() {
      if (
        this.roomtype == null ||
        this.quantity == null ||
        this.product == null
      ) {
        this.$message({
          type: "error",
          message: "Please select item!",
        });
        return;
      }

      axios
        .post("/roomtype/" + this.roomtype + "/product", {
          product: {
            rid: this.roomtype,
            artwork: this.product,
            quantity: this.quantity
          },
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.$router.push({ path: "/artwork/" + this.product._id });
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },

  computed: {
    filtered_projects: function () {
      var a = this.projectList.filter((p) => {
        return p.name.toLowerCase().includes(this.project_query.toLowerCase());
      });
      return this.sortArrayOfObjects(a, this.sortKey, this.reverseSort);
    },
  }
};
</script>

<style>
</style>
